import React, { useEffect, useRef, useState } from "react";
import "../Style/video.css";



import ServicesSection from "../components/videoservices";
import VideosbsServices from "../components/videosbs";
import GifSection from "../components/videogif";
import VideoProvide from "../components/videoprovide";
import VideoBenefits from "../components/videobenefits";
import VideoStack from "../components/videostack";
import Forms from "../components/Forms";
import DoubtsSection from "../components/videodoubts";
import ClientFeedback from "../components/Clientfeedback";
import PageFooter from "../components/Footer";


function VideoPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="video-page">
        {/* CSS-only pattern layers, no images */}
        <div className="video-grid-pattern" aria-hidden="true" />
        <div className="video-blob video-blob-1" aria-hidden="true" />
        <div className="video-blob video-blob-2" aria-hidden="true" />
        <div className="video-blob video-blob-3" aria-hidden="true" />

        <div
          className={`video-overlay ${isVisible ? "video-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="video-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="video-logo video-anim video-anim-1"
            /> */}

            <span className="video-eyebrow video-anim video-anim-2">
              Video Production Services
            </span>

            <h1 className="video-title video-anim video-anim-3">
              Strategic Video Production for Business Growth
            </h1>

            <p className="video-description video-anim video-anim-4">
              At MPeoples, we create impactful video content that boosts brand engagement and growth. From promos to corporate videos, we help you tell your story and reach the right audience.
            </p>

            <a href="#contactsec">
              <button className="video-btn video-anim video-anim-5">
                Let&rsquo;s Build Together <span>↗</span>
              </button>
            </a>
          </div>
        </div>
      </section>

      <ServicesSection />
      <VideosbsServices />
      <GifSection />
      <VideoProvide />
      <VideoBenefits />
      <VideoStack />
      <Forms />
      <DoubtsSection />
      <ClientFeedback />
      <PageFooter />
    </>
  );
}

export default VideoPage;